$(document).ready(function() {
    upsellBundleSlider();
});
$(document).on('shopify:section:select', upsellBundleSlider);
$(document).on('shopify:section:load', upsellBundleSlider);

const settingsMainSlider = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    fade: true,
    speed: 200,
    asNavFor: '.upsell-bundle-image-slider-thumb'
};

const settingsThumbnailSlider = {
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    speed: 200,
    asNavFor: '.upsell-bundle-image-slider',
    focusOnSelect: true,
    nextArrow: '<a class="nextArrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="65" viewBox="0 0 40 65" fill="none"><rect width="40" height="64" transform="translate(0 0.546875)" fill="url(#paint0_linear_2151_770)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M25.3431 24.8398L31.7071 31.2037C32.0976 31.5943 32.0976 32.2274 31.7071 32.6179L25.3431 38.9819C24.9526 39.3724 24.3194 39.3724 23.9289 38.9819C23.5384 38.5913 23.5384 37.9582 23.9289 37.5676L29.5857 31.9108L23.9289 26.254C23.5384 25.8635 23.5384 25.2303 23.9289 24.8398C24.3194 24.4492 24.9526 24.4492 25.3431 24.8398Z" fill="#E00000"/><defs><linearGradient id="paint0_linear_2151_770" x1="12" y1="63.7266" x2="1.24542e-06" y2="63.7266" gradientUnits="userSpaceOnUse"><stop stop-color="#FFFDF5"/><stop offset="1" stop-color="#FFFDF5" stop-opacity="0"/></linearGradient></defs></svg></a>',
    prevArrow: '<a class="prevArrow"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="65" viewBox="0 0 40 65" fill="none" style="transform: rotate(180deg)"><rect width="40" height="64" transform="translate(0 0.546875)" fill="url(#paint0_linear_2151_770)"/><path fill-rule="evenodd" clip-rule="evenodd" d="M25.3431 24.8398L31.7071 31.2037C32.0976 31.5943 32.0976 32.2274 31.7071 32.6179L25.3431 38.9819C24.9526 39.3724 24.3194 39.3724 23.9289 38.9819C23.5384 38.5913 23.5384 37.9582 23.9289 37.5676L29.5857 31.9108L23.9289 26.254C23.5384 25.8635 23.5384 25.2303 23.9289 24.8398C24.3194 24.4492 24.9526 24.4492 25.3431 24.8398Z" fill="#E00000"/><defs><linearGradient id="paint0_linear_2151_770" x1="12" y1="63.7266" x2="1.24542e-06" y2="63.7266" gradientUnits="userSpaceOnUse"><stop stop-color="#FFFDF5"/><stop offset="1" stop-color="#FFFDF5" stop-opacity="0"/></linearGradient></defs></svg></a>',
    responsive: [
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 4.75
            }
        }
    ]
};

function upsellBundleSlider() {
    if ($('.upsell-bundle-image-slider')) {
        $('.upsell-bundle-image-slider').slick(settingsMainSlider);
    }
    if ($('.upsell-bundle-image-slider-thumb')) {
        $('.upsell-bundle-image-slider-thumb').slick(settingsThumbnailSlider);
    }
}

$(document).on('click', '.section-tabs__link', function () {
    let activeHandle = $(this).attr('data-handle');
    $(".section-tabs__link").attr('aria-selected','false');
    $(`.section-tabs__link[data-handle=${activeHandle}]`).attr('aria-selected','true');

    openTabpanel($(this));
});

function openTabpanel(element) {
    let tabPanelId = element.attr('aria-controls'),
        tabPanel = $('#'+tabPanelId);

    $('.tabs__section').attr('data-aria-hidden','true').fadeOut(500);
    tabPanel.attr('data-aria-hidden','false').fadeIn(500);

    if (tabPanel.find('.upsell-bundle-image-slider.slick-slider').length > 0) {
        tabPanel.find('.upsell-bundle-image-slider.slick-slider').slick("unslick");
        tabPanel.find('.upsell-bundle-image-slider').slick(settingsMainSlider);
    }
    if (tabPanel.find('.upsell-bundle-image-slider-thumb.slick-slider').length > 0) {
        tabPanel.find('.upsell-bundle-image-slider-thumb.slick-slider').slick("unslick");
        tabPanel.find('.upsell-bundle-image-slider-thumb').slick(settingsThumbnailSlider);
    }
}